<template>
  <div class="login-bg">
    <div class="login-head">
      <div class="logo-holder">
        <div class="logo-holder-inner"
             :style="`background-image: url('${this.apiUrl}/${this.cfg.logoBlack}');`">
        </div>
      </div>
      <div class="logo-project">{{ this.cfg.projectCnName }}</div>
    </div>

    <Panel class="tabs mt10" :title="false">
      <div slot="content">
        <Panel class="login-panel" :title="false">
          <div slot="content" class="content">
            <div class="login-title">密码找回</div>

            <!-- 手机号 -->
            <div class="form-group">
              <div class="form-input-item">
                <div class="login-mobile"></div>
                <input class="form-control" v-model="formData.phone" placeholder="请填写手机号">
                <span class="required">*</span>
              </div>
            </div>

            <!-- 图形验证码 -->
            <div class="form-group">
              <div class="form-input-item">
                <div class="flex-dir-row">
                  <div class="flex-item-auto">
                    <div class="login-captcha"></div>
                    <input class="form-control" v-model="formData.captcha" placeholder="请填写图形验证码">
                  </div>
                  <div class="captcha-code">
                    <img :src="imgBase64" @click="changeCaptcha">
                  </div>
                </div>
              </div>
            </div>

            <!-- 短信验证码 -->
            <div class="form-group">
              <div class="form-input-item">
                <div class="flex-dir-row">
                  <div class="flex-item-auto">
                    <div class="login-sms"></div>
                    <input class="form-control" v-model="formData.smsCode" placeholder="请填写短信验证码">
                  </div>
                  <div class="sms-btn">
                    <button class="btn btn-outline" @click="sendSmsCode" :disabled="smsCountdown > 0" style="color: #1784A9 !important;">
                      {{ smsCountdown > 0 ? `${smsCountdown}s` : '获取验证码' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- 新密码 -->
            <div class="form-group">
              <div class="form-input-item">
                <div class="login-pwd"></div>
                <input class="form-control" v-model="formData.password" type="password" placeholder="请填写新密码">
                <span class="required">*</span>
              </div>
            </div>

            <!-- 确认密码 -->
            <div class="form-group">
              <div class="form-input-item">
                <div class="login-pwd"></div>
                <input class="form-control" v-model="formData.confirmPassword" type="password" placeholder="请确认新密码">
                <span class="required">*</span>
              </div>
            </div>

            <div class="btn dark-blue login-btn" @click="doReset">重置</div>
            <div style="text-align: center;margin-top: 15px">
              <span style="color: rgb(23,132,169);text-decoration: underline;" @click="backToLogin()">返回登录</span>
            </div>
          </div>
        </Panel>
      </div>
    </Panel>
  </div>
</template>
<style lang="scss" scoped>
.login-panel {
  .panel-title {
    font-size: 24px;
    font-weight: 700;
    color: #1f1f1f;
    margin-bottom: 5px;
  }

  .content {
    margin: 45px 28px;
    flex: 1;
    min-height: calc(100vh - 321px);
    padding-bottom: 20px;
  }

  .form-control {
    border-radius: 6px;
    border: 2px solid #F5F5F5;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    padding: 15px 15px 15px 45px;
  }
}

.login-title {
  color: #666;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 1px;
  text-align: center;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 16px;
}

.form-control::placeholder {
  color: #97a4af;
  opacity: 1;
}

.form-control {
  display: block;
  width: 100%;
  height: auto;
  padding: 12px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.2;
  color: #212529;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #eeeeff;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}

.form-input-item {
  position: relative;
}

.required {
  position: absolute;
  right: 12px;
  top: 17px;
  color: #ff4757;
  font-size: 14px;
}

.captcha-code, .sms-btn {
  width: 120px;
  margin-left: 10px;
}

.sms-btn .btn {
  width: 100%;
  height: 52px;
  font-size: 14px;
  border: 1px solid #1784A9;
  color: #1784A9;
  background: white;
  border-radius: 4px;
  cursor: pointer;
}

.sms-btn .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-bg {
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
}

.login-head {
  background: url("../assets/images/login-head.png");
  background-size: cover;
  height: 221px;
  padding-top: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.logo-holder {
  width: 92px;
  height: 92px;
  background: rgba(255, 255, 255, .3);
  border-radius: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-holder-inner {
  width: 84px;
  height: 84px;
  border-radius: 42px;
  overflow: hidden;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 90%;
}

.logo-project {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 17px;
  font-weight: 500;
  color: #FFFFFF;
}

.login-mobile, .login-pwd, .login-captcha, .login-sms {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  position: absolute;
  left: 16px;
  top: 17px;
}

.login-mobile {
  background-image: url("../assets/images/login-mobile.png");
}

.login-pwd {
  background-image: url("../assets/images/login-pwd.png");
}

.login-captcha {
  background-image: url("../assets/images/login-captcha.png");
}

.login-sms {
  background-image: url("../assets/images/login-captcha.png");
}

.login-btn {
  background: #1784A9 !important;
  margin-top: 30px;
}
</style>
<script>
import Panel from "@/components/Panel";
import {Toast} from 'mint-ui';
import {mapState} from 'vuex'
import md5 from 'js-md5';

export default {
  components: {
    Panel
  },
  data() {
    return {
      formData: {
        phone: '',
        captcha: '',
        smsCode: '',
        password: '',
        confirmPassword: ''
      },
      imgBase64: '',
      uuid: '',
      smsCountdown: 0,
      smsTimer: null
    }
  },
  computed: mapState({
    cfg(state) {
      return state.envs
    }
  }),
  mounted() {
    this.changeCaptcha()
  },
  beforeDestroy() {
    if (this.smsTimer) {
      clearInterval(this.smsTimer)
    }
  },
  methods: {
    backToLogin() {
      this.$router.push('/login')
    },
    isNull(value, msg) {
      if (!value) {
        Toast(msg)
        return true
      }
      return false
    },
    validatePhone(phone) {
      const re = /^1[3-9]\d{9}$/
      return re.test(phone)
    },
    doReset() {
      // 表单验证
      if (
          this.isNull(this.formData.phone, '手机号不能为空')
          || this.isNull(this.formData.captcha, '图形验证码不能为空')
          || this.isNull(this.formData.smsCode, '短信验证码不能为空')
          || this.isNull(this.formData.password, '新密码不能为空')
          || this.isNull(this.formData.confirmPassword, '确认密码不能为空')
      ) {
        return
      }

      // 密码确认验证
      if (this.formData.password !== this.formData.confirmPassword) {
        Toast('两次输入的密码不一致')
        return
      }

      // 手机号格式验证
      if (!this.validatePhone(this.formData.phone)) {
        Toast('请输入正确的手机号格式')
        return
      }

      const that = this
      const xjdyUrl = this.cfg.xjdyBUrl || ''
      if (!xjdyUrl) {
        Toast('配置错误，请联系管理员')
        return
      }

      // var md5_pwd = md5('vCzO5jIOLWb57wK0jg0NHcSlX5RbakDT-' + that.formData.password)

      this.$http.post(`${xjdyUrl}/system/user/forgotPassword`, {
        code: that.formData.captcha,
        password: that.formData.password,
        confirmPassword: that.formData.confirmPassword,
        phone: that.formData.phone,
        phoneCode: that.formData.smsCode,
        uuid: that.uuid
      }).then(response => {
        if (response.code == 200) {
          Toast('密码重置成功！请登录')
          that.$router.push('/login')
        } else {
          Toast(response.msg)
        }
      })
    },
    sendSmsCode() {
      if (this.isNull(this.formData.phone, '请先填写手机号')) {
        return
      }

      if (!this.validatePhone(this.formData.phone)) {
        Toast('请输入正确的手机号格式')
        return
      }

      if (this.isNull(this.formData.captcha, '请先填写图形验证码')) {
        return
      }

      const that = this
      const xjdyUrl = this.cfg.xjdyBUrl || ''
      if (!xjdyUrl) {
        Toast('配置错误，请联系管理员')
        return
      }

      this.$http.get(`${xjdyUrl}/center/webPage/getSmsCaptcha?phone=`+that.formData.phone+'&code='+that.formData.captcha+'&uuid='+that.uuid).then(response => {
        if (response.code === 200) {
          Toast('验证码已发送')
          that.startSmsCountdown()
        } else {
          Toast(response.msg)
        }
      })
    },
    startSmsCountdown() {
      this.smsCountdown = 60
      this.smsTimer = setInterval(() => {
        this.smsCountdown--
        if (this.smsCountdown <= 0) {
          clearInterval(this.smsTimer)
          this.smsTimer = null
        }
      }, 1000)
    },
    changeCaptcha() {
      const that = this
      const xjdyUrl = this.cfg.xjdyBUrl || ''
      if (!xjdyUrl) {
        console.error('xjdyUrl not found in cfg')
        return
      }

      this.$http.get(`${xjdyUrl}/captchaImage?v=${Math.random()}`).then(res =>{
        that.imgBase64 = `data:image/png;base64,`+res.img
        that.uuid = res.uuid
      })
    }
  }
}
</script>
